import { Box, Button, DialogBody, Stack } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, UI } from "components";
import { API } from "config";
import { toaster } from "config";
import { useEffect, useState } from "react";

export default function Configure({ ...props }){

    const queryClient = useQueryClient()
    const [ pin, setPin ] = useState()
    const [ pin_retype, setPinRetype ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleReset = () => {
        setPin(null)
        setPinRetype(null)
    }

    const handleSubmit = async () => {
        if(!pin || !pin_retype) return
        setLoading(true)
        
        try{
            await API.put('/me/security-code', { security_code: pin })
            toaster.create({ title: 'Código de segurança alterado', type: 'success' })
            handleReset()
            queryClient.invalidateQueries('user')
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível configurar o código de segurança. Tente novamente!', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
        handleReset()
    }

    useEffect(() => {
        if(!!pin_retype && pin === pin_retype) handleSubmit()
    }, [pin_retype])

    return(
    <UI.Dialog loading={loading} size="sm" title="Configurar código de segurança" {...props}>
        <DialogBody>
            <Stack gap={4}>

                <UI.Alert size="sm" colorPalette="gray">O código de segurança (antiga senha financeira) é requerido em várias ações no seu escritório, principalmente financeiras, como pagamentos de terceiros e ativações.</UI.Alert>

                <UI.Show visible={!pin}><Form.Pin required autoFocus blurOnComplete size="lg" label="Digite um código:" onValueComplete={e => setPin(e.valueAsString)} /></UI.Show>
                <UI.Show visible={!!pin}><Form.Pin required autoFocus blurOnComplete size="lg" label="Repita o código:" onValueComplete={e => setPinRetype(e.valueAsString)} /></UI.Show>
                
                <UI.Show visible={!!pin && !!pin_retype && (pin !== pin_retype)}><UI.Alert size="sm" status="error">Os códigos não coincidem. Tente novamente!</UI.Alert></UI.Show>
                <UI.Show visible={!!pin}><Box><Button variant="ghost" size="sm" colorPalette="yellow" onClick={handleReset} loading={loading} loadingText="Configurando código..."><UI.Icon name="edit" /> Corrigir</Button></Box></UI.Show>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}